import * as React from 'react';
import { useState } from 'react';
import { Field, withTypes } from 'react-final-form';
import axios from 'axios';
import {
  Button,
  CardActions,
  CircularProgress,
  TextField,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Notification, useTranslate, useNotify } from 'react-admin';
import { ENDPOINTS } from '../apiConstants';
import { getConfigGet } from '../getConfig';
import { ShowData } from './transferRewardAmount';

const useStyles = makeStyles(() => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  form: {
    padding: '0 1em 1em 1em',
    width: '100%',
    maxWidth: 520,
    margin: '0 auto',
  },
  input: {
    marginTop: '1em',
    width: '100%',
  },
  actions: {
    padding: '0 1em 1em 1em',
    width: '100%',
    maxWidth: 520,
    margin: '0 auto',
  },
  tableCell: {
    padding: '4px 8px',
    border: '1px solid gray',
    whiteSpace: 'pre-line' as const,
    fontSize: '0.8rem',
  },
  tableTitle: {
    textAlign: 'center',
    marginTop: '1.5em',
  },
}));

const renderInput = ({
  meta: { touched, error } = { touched: false, error: undefined },
  input: { ...inputProps },
  ...props
}: any) => (
  <TextField
    error={!!(touched && error)}
    helperText={touched && error}
    {...inputProps}
    {...props}
    fullWidth
  />
);

interface FormValues {
  EmailOrId?: string | number;
}

const { Form } = withTypes<FormValues>();

const UserSessionInfo = () => {
  const translate = useTranslate();
  const classes = useStyles();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const [sessionData, setSessionData] = useState<any[]>([]);
  const [tableTitle, setTableTitle] = useState('');

  const handleSubmit = (inputData: FormValues) => {
    setSessionData([]);
    setLoading(true);
    notify('pos.fetching_the_result');

    const { EmailOrId } = inputData;
    let config;

    if (/^[a-zA-Z0-9]{8}$/.test(String(EmailOrId))) {
      config = getConfigGet({ referral_code: EmailOrId });
    } else if (isNaN(Number(EmailOrId))) {
      config = getConfigGet({ email: EmailOrId });
    } else if (String(EmailOrId).length < 10) {
      config = getConfigGet({ id: EmailOrId });
    } else {
      config = getConfigGet({ pps_account_number: EmailOrId });
    }

    axios.get(ENDPOINTS.USER_SESSION_INFO, config)
      .then((res: any) => {
        const response = res?.data?.[0];
        setTableTitle(response?.tableList?.[0] || 'User Session');
        setSessionData(response?.sessionInfo?.[0] || []);
      })
      .catch((error) => {
        notify(
          error?.response?.data?.message || 'Failed to fetch user session info',
          'error',
          '',
          undefined,
          50000
        );
      })
      .finally(() => setLoading(false));
  };

  const validate = (values: FormValues) => {
    const errors: FormValues = {};
    if (!values.EmailOrId) {
      errors.EmailOrId = translate('ra.validation.required');
    }
    return errors;
  };

  return (
    <Form
      onSubmit={handleSubmit}
      validate={validate}
      render={({ handleSubmit }) => (
        <div>
          <form onSubmit={handleSubmit} noValidate>
            <div className={classes.main}>
              <div className={classes.form}>
                <div className={classes.input}>
                  <Field
                    autoFocus
                    name="EmailOrId"
                    // @ts-ignore
                    component={renderInput}
                    label={translate('pos.buttons.email_or_user_id')}
                    disabled={loading}
                  />
                </div>
              </div>
              <CardActions className={classes.actions}>
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disabled={loading}
                  fullWidth
                >
                  {loading && <CircularProgress size={25} thickness={2} />}
                  Fetch User Session Info
                </Button>
              </CardActions>
              <Notification />
            </div>
          </form>

          {sessionData.length > 0 && (
            <>
              <h3 className={classes.tableTitle}>{tableTitle}</h3>
              <ShowData
                record={sessionData}
                tableCenterAlign={false}
                dataGridStyle={classes.tableCell}
              />
            </>
          )}
        </div>
      )}
    />
  );
};

export default UserSessionInfo;
